import { FC } from 'react';
import JobDetails from 'containers/jobs/job-details/JobDetails';
import { selectIsActionsBlocked } from 'containers/app/appSlice';
import { useAppSelector } from 'hooks';
import MerchantOrTeamBlockedInfo from 'components/merchant-or-team-blocked/MerchantOrTeamBlockedInfo';

const JobDetailsPage: FC = () => {
  const isActionsBlocked = useAppSelector(selectIsActionsBlocked);

  if (isActionsBlocked) {
    return <MerchantOrTeamBlockedInfo title="Job Details" />;
  }
  return <JobDetails />;
};

export default JobDetailsPage;
